<template>
  <!-- 已办任务 -->
  <div style="position: relative;">
    <el-form ref="formMyApprovedTask"  style="margin:5px 0" :model="formFilter" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item label="流水号" prop="serialNo">
            <el-input v-model="formFilter.serialNo" :clearable="true" placeholder="流水号"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="流程名称" prop="processDefinitionName">
            <el-select style="width:100%" v-model="formFilter.processDefinitionName" placeholder="流程名称" clearable>
              <el-option-group
                v-for="group in options"
                :key="group.processDefinitionKey"
                :label="group.processDefinitionName">
                <el-option
                  v-for="item in group.children"
                  :key="item.processDefinitionKey"
                  :label="item.processDefinitionName"
                  :value="item.processDefinitionName">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发起时间" prop="createDate">
            <date-range style="width:100%"
              v-model="formFilter.createDate"
              :clearable="true" :allowTypes="['day']" align="left"
              range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工程名称/文号" prop="runName">
            <el-input
              v-model="formFilter.runName"
              :clearable="true" placeholder="工程名称/文号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工程名称" prop="formFilter.gcmc">
            <el-select style="width:100%" filterable  :clearable="true" v-model="formFilter.gcmc" placeholder="工程名称">
              <el-option
                v-for="(item,index) in projectList"
                :key="index"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="合同名称" prop="formFilter.htmc">
            <el-select style="width:100%" filterable  :clearable="true" v-model="formFilter.htmc" placeholder="合同名称">
              <el-option
                v-for="(item,index) in contractList"
                :key="index"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-button type="primary" :plain="true" :size="defaultFormItemSize" @click="handleSearch">查询</el-button>
            <el-button type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="teacher" :data="handlerTaskWidget.dataList" :size="defaultFormItemSize" @sort-change="handlerTaskWidget.onSortChange"
          header-cell-class-name="table-header-gray">
          <el-table-column label="流水号" prop="serialNo" width="130px"  />
          <!-- <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="handlerTaskWidget.getTableIndex" /> -->
          <el-table-column label="流程名称" prop="processDefinitionName" width="200px" />
          <el-table-column label="文号" prop="runName" width="600px"/>
          <el-table-column label="任务名称" prop="name"  width="200px"/>
          <el-table-column label="执行操作" width="150px">
            <template slot-scope="scope">
              <span>{{SysFlowTaskOperationType.getValue(scope.row.approvalType)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="发起时间" prop="createTime"/>
          <el-table-column label="操作" fixed="right" width="120px">
            <template slot-scope="scope">
              <!-- <el-button class="table-btn primary " :size="defaultFormItemSize" type="text" @click="onRemindClick(scope.row)">催办</el-button> -->
              <el-button class="table-btn" :size="defaultFormItemSize" type="text" @click="getFlow(scope.row)">流程图</el-button>
              <el-button class="table-btn success" :size="defaultFormItemSize" type="text" @click="onTaskDetail(scope.row)">详情</el-button>
              <!-- <el-button class="table-btn delete" :size="defaultFormItemSize" type="text" @click="onCancelWorkOrder(scope.row)">撤销</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="handlerTaskWidget.totalCount"
            :current-page="handlerTaskWidget.currentPage"
            :page-size="handlerTaskWidget.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="handlerTaskWidget.onCurrentPageChange"
            @size-change="handlerTaskWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>    
    <el-dialog
      :visible="visible"
      width="1000px"
      top='5vh'
      :before-close="onClose"
    >
      <formTaskProcessViewer v-if="record.processDefinitionId && visible"  :flag="false"  :processDefinitionId='record.processDefinitionId'  :processInstanceId='record.processInstanceId' />
    </el-dialog>
  </div>
</template>

<script>
// import { Dialog } from 'element-ui'
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { TableWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
import { FlowOperationController } from '@/api/flowController.js';
import formTaskProcessViewer from "./formTaskProcessViewer.vue";
import { OnlineOperation } from '@/api/onlineController.js';

export default {
  name: 'formMyApprovedTask',
  props:{
    options:{
      type :Array,
      default : () => []
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  components:{
    formTaskProcessViewer
  },
  props:{
    options:{
      type :Array,
      default : () => []
    }
  },
  data () {
    return {
      formFilter: {
        processDefinitionName: undefined,
        serialNo:'',
        runName: '',
        createDate: [],
        gcmc:undefined,
        htmc:undefined
      },
      formFilterCopy: {
        processDefinitionName: undefined,
        serialNo:'',
        runName:'',
        createDate: [],
        gcmc:undefined,
        htmc:undefined
      },
      handlerTaskWidget: new TableWidget(this.loadHandlerTaskData, this.loadHandlerTaskVerify, true, false,null,false,null,localStorage.getItem('page') ? JSON.parse(localStorage.getItem('page')).pageParam.pageNum : 1),
      isInit: false,
      record:{},
      visible:false,
      projectList:[],
      contractList:[]
    }
  }, 
  created(){
    this.init()
    const row = JSON.parse(localStorage.getItem('task'))
    if (row) {
      this.onTaskDetail(row)
    }
    const search = JSON.parse(localStorage.getItem('search'))
    if (search) {
      this.formFilter = search
      this.formFilterCopy = search
    }
  },
  mounted() {
    localStorage.removeItem('page')
  },
  methods: {
    handleSearch(){
      this.refreshFormMyApprovedTask(true)
      localStorage.removeItem('page')
    },
    init(){
      OnlineOperation.listDict(this, {
        dictId: '1637650160030846976'
      }).then(res=>{
        this.projectList = res.data
      })
      OnlineOperation.listDict(this, {
        dictId: '1684463201976061952'
      }).then(res=>{
        this.contractList = res.data
      })
    },
    onReset () {
      this.formFilter= {
        processDefinitionName: undefined,
        serialNo:'',
        runName: '',
        createDate: [],
        gcmc:undefined,
        htmc:undefined
      }
      this.formFilterCopy= {
        processDefinitionName: undefined,
        serialNo:'',
        runName:'',
        createDate: [],
        gcmc:undefined,
        htmc:undefined
      },
      this.refreshFormMyApprovedTask(true);
    },
    // // 催办
    // onRemindClick (row) {
    //   FlowOperationController.remindRuntimeTask(this, {
    //     workOrderId: row.workOrderId
    //   }).then(res => {
    //     this.$message.success('催办成功');
    //   }).catch(e => {});
    // },
    // // 撤销
    // onCancelWorkOrder (row) {
    //   this.$confirm('是否撤销此工单？').then(res => {
    //     let params = {
    //       workOrderId: row.workOrderId,
    //       cancelReason: '主动撤销'
    //     }
    //     FlowOperationController.cancelWorkOrder(this, params).then(res => {
    //       this.$message.success('撤销成功！');
    //       this.refreshFormMyApprovedTask(false);
    //     }).catch(e => {});
    //   }).catch(e => {});
    // },
    /**
     * 获取已办任务列表
     */
    loadHandlerTaskData (params) {
      if (params == null) params = {};
      if(params.pageParam.pageNum !== 1) {
        localStorage.setItem('page',JSON.stringify(params))
      } else {
        localStorage.removeItem('page')
      }
      params = {
        ...params,
        processDefinitionName: this.formFilterCopy.processDefinitionName,
        serialNo: this.formFilterCopy.serialNo,
        runName: this.formFilterCopy.runName,
        beginDate: this.formFilterCopy.createDate[0],
        endDate: this.formFilterCopy.createDate[1],
        gcmc:this.formFilterCopy.gcmc,
        htmc:this.formFilterCopy.htmc
      }
      return new Promise((resolve, reject) => {
        FlowOperationController.listHistoricTask(this, params).then(res => {
          resolve({
            dataList: res.data.dataList.map(item => {
              let formInfo = JSON.parse(item.formKey);
              return {
                ...item,
                formInfo
              }
            }),
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 校验已办任务过滤参数
     */
    loadHandlerTaskVerify () {
      this.formFilterCopy.processDefinitionName = this.formFilter.processDefinitionName;
      this.formFilterCopy.serialNo = this.formFilter.serialNo;
      this.formFilterCopy.runName =  this.formFilter.runName;
      this.formFilterCopy.gcmc = this.formFilter.gcmc
      this.formFilterCopy.htmc = this.formFilter.htmc
      this.formFilterCopy.createDate = Array.isArray(this.formFilter.createDate) ? [...this.formFilter.createDate] : [];
      return true;
    },
    /**
     * 刷新已办任务列表
     */
    refreshFormMyApprovedTask (reloadData = false) {
      if (reloadData) {
        this.handlerTaskWidget.refreshTable(true, 1);
      } else {
        this.handlerTaskWidget.refreshTable();
      }
      localStorage.setItem('search',JSON.stringify(this.formFilterCopy))
    },
    /**
     * 详情
     */
    onTaskDetail (row) {
      localStorage.setItem('task',JSON.stringify(row))
      let params = {
        taskId: row.id,
        processDefinitionId: row.processDefinitionId,
        processInstanceId: row.processInstanceId
      }
      FlowOperationController.viewHistoricTaskInfo(this, params).then(res => {
        
        if(row.processDefinitionName === "付款审批单") {
          FlowOperationController.listWorkOrder(this, {
            flowWorkOrderDtoFilter: {
              serialNo:row.serialNo
            },
            pageParam:{
              pageSize:1,
              pageNum: 1
            }
          }, {
            processDefinitionKey: 'all'
          }).then(rs => {

        this.$router.push({
          name: res.data.routerName || 'handlerFlowTask',
          query: {
            serialNo:row.serialNo,
            processDefinitionKey: row.processDefinitionKey,
            taskId: row.id,
            processInstanceId: row.processInstanceId,
            processDefinitionId: row.processDefinitionId,
            formId: (row.formInfo || {}).formId,
            routerName: row.routerName,
            readOnly: true,
            flowEntryName: row.processDefinitionName,
            processInstanceInitiator: row.processInstanceInitiator,
            // 在已办理任务中仅显示加签和撤销操作
            operationList: res.data.operationList.filter(item => {
              return item.type === this.SysFlowTaskOperationType.CO_SIGN || item.type === this.SysFlowTaskOperationType.REVOKE;
            }),
            flowStatus: rs.data.dataList[0] && rs.data.dataList[0].flowStatus === 3 ?  '已办结' : '未办结',
            flag: false, // change wang 2023/3/10
            form:true
          }
        });
          })
        } else {
          
        this.$router.push({
          name: res.data.routerName || 'handlerFlowTask',
          query: {
            serialNo:row.serialNo,
            processDefinitionKey: row.processDefinitionKey,
            taskId: row.id,
            processInstanceId: row.processInstanceId,
            processDefinitionId: row.processDefinitionId,
            formId: (row.formInfo || {}).formId,
            routerName: row.routerName,
            readOnly: true,
            flowEntryName: row.processDefinitionName,
            processInstanceInitiator: row.processInstanceInitiator,
            // 在已办理任务中仅显示加签和撤销操作
            operationList: res.data.operationList.filter(item => {
              return item.type === this.SysFlowTaskOperationType.CO_SIGN || item.type === this.SysFlowTaskOperationType.REVOKE;
            }),
            flowStatus: '未办结',
            flag: false,// change wang 2023/3/10
            form:true
          }
        });
        }
      }).then(res => {});
    },
    onResume () {
      this.refreshFormMyApprovedTask();
    },
    initFormData () {
    },
    formInit () {
      this.refreshFormMyApprovedTask();
    },
    // 查看流程图
    getFlow(record){
      this.record = record
      this.visible = true
    },
    onClose(){
      this.visible = false
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style>
</style>
